const algoliaAppId = 'D2BGZ2G5J2'
const algoliaApiKey = '915e00e713a6a916d7cfd177c1546c9d'
const trainingSearchIndex = 'training_search'
const trainingSearchSuggestionsIndex = 'training_search_query_suggestions'

export {
  algoliaAppId,
  algoliaApiKey,
  trainingSearchIndex,
  trainingSearchSuggestionsIndex,
}
